// extracted by mini-css-extract-plugin
export default {"default":"H6JIKYaV","success":"DVe_byPI","error":"X_KenjRf","general":"WfX8lCzF"};